var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("path",{"fillRule":"nonzero","d":"M11.459 11.311l-8.25 8.152a1.895 1.895 0 01-2.644 0 1.84 1.84 0 010-2.612l6.907-6.846L.544 3.16a1.84 1.84 0 010-2.612A1.905 1.905 0 011.865 0c.49 0 .96.19 1.322.548l8.25 8.151c.747.716.747 1.896.022 2.612z"})));
}

ChevronRight.defaultProps = {"viewBox":"0 0 12 20"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
